import { FC } from 'react';
import styled from 'styled-components';
import { Avatar } from '../Avatar/Avatar';
import { AccessibleRoleProp } from './List';

const ListItemCompactElement = styled.div`
  word-break: break-word;
  display: flex;
  align-items: center;
  padding: 20px;
  margin-bottom: 15px;
  border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
  border-radius: ${({ theme }) => theme.vars.borderRadius.default};
`;

const AvatarElement = styled.div`
  margin-right: 25px;
`;

const ChildrenElement = styled.div`
  > * {
    margin-bottom: 15px;
  }
`;

const OptionsElement = styled.div`
  display: flex;
`;

interface IProps extends AccessibleRoleProp {
  /**
   * SVG icon for the avatar
   */
  avatarIcon?: string;
  /**
   * Image URL used to render an avatar image
   */
  avatarImage?: string;
  /**
   * Avatar background color
   */
  avatarBg?: string;
  /**
   * Avatar icon color
   */
  avatarColor?: string;
  /**
   * A slot for the list item options, for example an edit button.
   */
  options?: JSX.Element;
}

export const ListItemCompact: FC<IProps> = props => {
  return (
    <ListItemCompactElement data-testid="ListItemCompact">
      {(props.avatarIcon || props.avatarImage) && (
        <AvatarElement>
          <Avatar icon={props.avatarIcon} image={props.avatarImage} bg={props.avatarBg} color={props.avatarColor} />
        </AvatarElement>
      )}
      <div>
        <ChildrenElement>{props.children}</ChildrenElement>
        {props.options && <OptionsElement data-testid="ListItemCompactOptions">{props.options}</OptionsElement>}
      </div>
    </ListItemCompactElement>
  );
};

ListItemCompact.defaultProps = { role: 'listitem' };
